import { MapRow } from '@/components/Map/Map'

export interface MapRowMachine {
  id: string | undefined
  name: string | undefined
  internalNumber: string | undefined
  type: {
    manufacturer: string;
    category: string;
    model: string;
  }
}

export interface MapRowstatus {
  fire: boolean | null
}

export interface MapResponse {
  time: string // ISO 8601 string representation of the latest DtServer
  rows: MapRow[] | null   // Array of MapRow objects
}

export function mergeMapResponses(oldResponse: MapResponse, newResponse: MapResponse): MapResponse {
  if (!newResponse.rows) {
    return oldResponse
  }
  const updatedRows: MapRow[] = oldResponse.rows ? [...oldResponse.rows] : []
  const imeiMap = new Map<string, MapRow>(updatedRows.map(row => [row.imei, row]))
  for (const newRow of newResponse.rows) {
    imeiMap.set(newRow.imei, newRow)
  }
  const mergedRows = Array.from(imeiMap.values());
  return {
    time: newResponse.time,
    rows: mergedRows,
  }
}
